import { transformSuggestions as genericTransformSuggestions } from "../autocomplete/utils";
import type { PlaceSuggestion, SuggestionItem } from "./types";

// Create Bangalore bounds for location restriction
export const createBengaluruBounds = () => {
	return new window.google.maps.LatLngBounds(
		new window.google.maps.LatLng(12.70449, 77.318748),
		new window.google.maps.LatLng(13.471908, 78.046592),
	);
};

// Transform place suggestions into suggestion items
export const transformSuggestions = (
	suggestions: PlaceSuggestion[],
	isLoading: boolean,
	inputValue: string,
	isValueSelected: boolean = false,
): SuggestionItem[] => {
	return genericTransformSuggestions<PlaceSuggestion>(
		suggestions,
		isLoading,
		inputValue,
		isValueSelected,
		"Searching...",
		"No results found",
		suggestion => ({
			id: suggestion.placeId,
			text: suggestion.mainText,
			secondaryText: suggestion.secondaryText,
			isPlaceholder: false,
		}),
	);
};
